import type { StoreResponseInterface } from '@nts/std/interfaces';
import { GenericServiceResponse } from './generic-service-response';
import type { IdentityInterface, ModelInterface } from '@nts/std/interfaces';

export class StoreResponse<
    TModel extends ModelInterface<TIdentity>,
    TIdentity extends IdentityInterface
> extends GenericServiceResponse<TModel>
    implements StoreResponseInterface<TModel, TIdentity> {

}
